<template>

    <trax-ui-ajax-form-in-modal :id="id" :endpoint="endpoint" 
        :props="props" :titles="titles" :bus="bus" :form="form" icons="1">

        <trax-ui-input type="text" icon="person" :placeholder="lang.polaris.account.username"
            v-model="form.username" :error="errors.username" required="1" :disabled="!internal" v-if="withUsername">
        </trax-ui-input>

        <trax-ui-input type="email" icon="email" :placeholder="lang.polaris.account.email"
            v-model="form.email" :error="errors.email" required="1" :disabled="!internal">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.account.firstname"
            v-model="form.firstname" :error="errors.firstname" required="1" :disabled="!internal">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.account.lastname"
            v-model="form.lastname" :error="errors.lastname" required="1" :disabled="!internal">
        </trax-ui-input>

        <trax-ui-select icon="dns" v-model="form.source" :options="user_sources_select" disabled="1" v-show="!internal">
        </trax-ui-select>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'withUsername'],
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/users",
                id: 'trax-account-user-edit',
                form: {},
                errors: {},
                user_sources_select: data.user_sources_select,
                props: {
                    id: { source:'id' },
                    username: { source:'username' },
                    email: { source:'email' },
                    firstname: { source:'firstname' },
                    lastname: { source:'lastname' },
                    source: { source:'source', default:'internal' }
                },
                titles: {
                    new: lang.polaris.account.new_user,
                    update: lang.polaris.account.user_update
                }
            }
        },

        computed: {

            internal: function () {
                return this.form.source == 'internal';
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        }

    }
</script>
